import React, { useState, useEffect } from "react";
import { FileText, Download, Tag, Sparkles } from "lucide-react";
import { useStateContex } from "../../Context/UseStateContet";
import { useAPI } from "../../Context/MyContext";
import { FaCopy, FaExternalLinkAlt, FaPhoneAlt, FaReply, FaWhatsapp } from "react-icons/fa";

const TemplateMessage = ({ template,
  //  GetMediaUrl,
  phone_number_id }) => {
  const { selectedWabaId } = useStateContex();
  const [mediaCache, setMediaCache] = useState({});
  const { GetMediaUrl } = useAPI();

  // Fetch media if needed
  const fetchMedia = async (id) => {
    if (mediaCache[id]) return mediaCache[id];
    try {
      // console.log(`Fetching media for ID: ${id}`);
      const url = await GetMediaUrl(id, phone_number_id, selectedWabaId);
      setMediaCache((prev) => ({ ...prev, [id]: url }));
      return url;
    } catch (err) {
      console.error("Media fetch failed:", err);
      return null;
    }
  };
  // console.log("template are hare :", template);

  const renderComponent = (comp, idx) => {
    switch (comp.type?.toUpperCase()) {
      case "HEADER": {
        // console.log("Header Text:", comp);

        const param = comp.parameters?.[0];

        if (comp.format === "TEXT" && comp.text) {
          // console.log("Header Text in IF Condition:", comp);
          return (
            <div key={idx} className="px-4 pt-2 pb-1">
              <p className="text-base font-bold text-gray-900">{comp.text}</p>
            </div>
          );
        }

        // IMAGE HEADER
        if (comp.format === "IMAGE" && param?.image?.id) {
          const src = param.image?.link || mediaCache[param.image?.id];
          if (!src) fetchMedia(param.image.id);
          return (
            <img
              key={idx}
              src={src}
              alt="Header Image"
              className="w-full h-auto object-cover"
              style={{ maxHeight: 300 }}
            />
          );
        }

        // VIDEO HEADER
        if (comp.format === "VIDEO" && param?.video?.id) {
          const src = param.video?.link || mediaCache[param.video?.id];
          if (!src) fetchMedia(param.video.id);
          return (
            <video
              key={idx}
              src={src}
              controls
              className="w-full h-auto rounded-t-lg"
              style={{ maxHeight: 300 }}
            />
          );
        }

        // DOCUMENT HEADER
        if (comp.format === "DOCUMENT" && param?.document?.id) {
          const src = param.document?.link || mediaCache[param.document?.id];
          if (!src) fetchMedia(param.document.id);
          return (
            <a
              key={idx}
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-blue-50 flex items-center gap-2"
            >
              <FileText size={20} className="text-blue-600" />
              <span className="text-blue-700 text-sm font-medium">
                {param.document?.filename || "View Document"}
              </span>
              <Download size={16} className="text-blue-600 ml-auto" />
            </a>
          );
        }
        return null;
      }

      case "BODY": {
        let text = comp.text || "";
        if (comp.parameters?.length) {
          comp.parameters.forEach((p, i) => {
            text = text.replace(`{{${i + 1}}}`, p.text || "");
          });
        }
        return (
          <div key={idx} className="px-4 py-2">
            <p className="text-sm text-gray-800 whitespace-pre-wrap">{text}</p>
          </div>
        );
      }

      case "FOOTER": {
        const text = comp.text || comp.parameters?.[0]?.text;
        if (!text) return null;
        return (
          <div key={idx} className="px-4 pb-2">
            <p className="text-xs text-gray-500">{text}</p>
          </div>
        );
      }

      // case "BUTTONS": {
      //   if (!comp.buttons?.length) return null;

      //   return (
      //     <div key={idx} className="px-4 pb-3 pt-2 flex flex-col gap-2">
      //       {comp.buttons.map((btn, btnIdx) => {

      //         // PHONE NUMBER BUTTON
      //         if (btn.type === "PHONE_NUMBER") {
      //           return (
      //             <a
      //               key={btnIdx}
      //               href={`tel:${btn.phone_number}`}
      //               className="block w-full text-center px-4 py-2.5 bg-white hover:bg-gray-50 
      //                    border border-gray-300 rounded-lg text-sm font-medium 
      //                    text-blue-600 transition-colors"
      //             >
      //               📞 {btn.text}
      //             </a>
      //           );
      //         }

      //         // URL BUTTON
      //         if (btn.type === "URL") {
      //           return (
      //             <a
      //               key={btnIdx}
      //               href={btn.url}
      //               target="_blank"
      //               rel="noopener noreferrer"
      //               className="block w-full text-center px-4 py-2.5 bg-white hover:bg-gray-50 
      //                    border border-gray-300 rounded-lg text-sm font-medium 
      //                    text-blue-600 transition-colors"
      //             >
      //               🔗 {btn.text}
      //             </a>
      //           );
      //         }

      //         // QUICK REPLY BUTTON
      //         if (btn.type === "QUICK_REPLY") {
      //           return (
      //             <button
      //               key={btnIdx}
      //               className="w-full px-4 py-2.5 bg-white hover:bg-gray-50 
      //                    border border-gray-300 rounded-lg text-sm font-medium 
      //                    text-blue-600 transition-colors"
      //             >
      //               {btn.text}
      //             </button>
      //           );
      //         }

      //         // COPY CODE BUTTON
      //         if (btn.type === "COPY_CODE") {
      //           return (
      //             <button
      //               key={btnIdx}
      //               className="w-full px-4 py-2.5 bg-white hover:bg-gray-50 
      //                    border border-gray-300 rounded-lg text-sm font-medium 
      //                    text-blue-600 transition-colors"
      //             >
      //               🎟️ {btn.text}
      //             </button>
      //           );
      //         }

      //         // WHATSAPP CALL BUTTON  (VOICE_CALL)
      //         if (btn.type === "VOICE_CALL") {
      //           return (
      //             <button
      //               key={btnIdx}
      //               className="block w-full text-center px-4 py-2.5 bg-white hover:bg-gray-50 
      //                    border border-gray-300 rounded-lg text-sm font-medium 
      //                    text-blue-600 transition-colors"
      //             >
      //               📞 {btn.text}
      //             </button>
      //           );
      //         }

      //         return null;
      //       })}
      //     </div>
      //   );
      // }





case "BUTTONS": {
  if (!comp.buttons?.length) return null;

  return (
    <div
      key={idx}
      className="px-4 pb-4 pt-3 flex flex-col gap-3 border-t border-gray-200"
    >
      {comp.buttons.map((btn, btnIdx) => {
        const baseClass =
          "w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-sm font-semibold border transition-all duration-300 shadow-sm hover:shadow-md hover:scale-[1.02]";

        // PHONE NUMBER BUTTON
        if (btn.type === "PHONE_NUMBER") {
          return (
            <a
              key={btnIdx}
              href={`tel:${btn.phone_number}`}
              className={`${baseClass} bg-green-50 border-green-200 text-green-700 hover:bg-green-100`}
            >
              <FaPhoneAlt className="text-green-500" />
              {btn.text}
            </a>
          );
        }

        // URL BUTTON
        if (btn.type === "URL") {
          return (
            <a
              key={btnIdx}
              href={btn.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`${baseClass} bg-purple-50 border-purple-200 text-purple-700 hover:bg-purple-100`}
            >
              <FaExternalLinkAlt className="text-purple-500 text-sm" />
              {btn.text}
            </a>
          );
        }

        // QUICK REPLY BUTTON
        if (btn.type === "QUICK_REPLY") {
          return (
            <button
              key={btnIdx}
              className={`${baseClass} bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100`}
            >
              <FaReply className="text-blue-500" />

              {btn.text}
            </button>
          );
        }

        // COPY CODE BUTTON
        if (btn.type === "COPY_CODE") {
          return (
            <button
              key={btnIdx}
              className={`${baseClass} bg-yellow-50 border-yellow-200 text-yellow-700 hover:bg-yellow-100`}
            >
              <FaCopy className="text-yellow-500" />
              {btn.text}
            </button>
          );
        }

        // WHATSAPP / VOICE CALL BUTTON
        if (btn.type === "VOICE_CALL") {
          return (
            <button
              key={btnIdx}
              className={`${baseClass} bg-emerald-50 border-emerald-200 text-emerald-700 hover:bg-emerald-100`}
            >
              <FaWhatsapp className="text-emerald-500 text-lg" />
              {btn.text}
            </button>
          );
        }

        return null;
      })}
    </div>
  );
}

      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col w-80 bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200">
      {/* Template Header Badge */}
      <div className="relative">
        <div className="flex items-center gap-2 bg-gradient-to-r from-violet-500 via-purple-500 to-indigo-500 px-4 py-2.5">
          <Sparkles size={12} className="text-white" />
          <span className="text-xs font-bold text-white tracking-wider uppercase">
            Template
          </span>
          <div className="ml-auto flex items-center gap-1.5 px-2.5 py-1 bg-white/20 backdrop-blur-sm rounded-full">
            <Tag size={10} className="text-white" />
            <span className="text-[10px] font-semibold text-white uppercase tracking-wide">
              {template.name}
            </span>
          </div>
        </div>
      </div>

      {/* Components */}
      <div className="bg-gradient-to-b from-gray-50 to-white">
        {template.components?.map((comp, idx) => renderComponent(comp, idx))}
      </div>
    </div>
  );
};

export default TemplateMessage;
